import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateComponents } from 'src/app/constants/global-constants';
import { IBooking, IBookingUpdateResponse, IMumsBooking } from 'src/app/models/dashboard.models';
import { DashboardService } from 'src/app/services/dashboard.service';
declare var $: any;

@Component({
  selector: 'app-view-booking',
  templateUrl: './view-booking.component.html',
  styleUrls: ['./view-booking.component.scss']
})
export class ViewBookingComponent implements OnInit {

  bookingDetails: IBooking;
  bookingDetailMum: IMumsBooking;
  bookingDates: Array<any> = [];
  dueDate: Date;

  fromDaysDrop :Array<string> ;
  toDaysDrop :Array<string> ;
  daysBackup : Array<string> = DateComponents.days ;
  months = DateComponents.months;
  years = ['2021', '2022', '2023', '2024'];
  today = new Date();
  Days31 = DateComponents.days31;
  Days30 = DateComponents.days30;

  fromDateError: boolean = false;
  toDateError: boolean = false;

  fromDate: Date = new Date();
  toDate: Date = new Date();

  bookingForm = new FormGroup({
    fromDay: new FormControl('', Validators.required),
    fromMonth: new FormControl('', Validators.required),
    fromYear: new FormControl('', Validators.required),
    toDay: new FormControl('', Validators.required),
    toMonth: new FormControl('', Validators.required),
    toYear: new FormControl('', Validators.required)
  });

  loading: boolean = false;
  @Output() refresh = new EventEmitter();

  constructor(private dashboardService: DashboardService) { }

  ngOnInit(): void {
  }

  generateBookingDatesMidwife(){
    this.bookingDates = [];
    let sample: Array<any> = [];
    sample.push(this.bookingDetails.startDate);
    sample.push(this.bookingDetails.endDate);
    sample.push(this.bookingDetails.mumBooked[0].dueDate);
    this.dueDate = new Date(this.bookingDetails.mumBooked[0].dueDate);
    sample = Array.from(new Set(sample));
    sample.forEach(date=>this.bookingDates.push(new Date(date)));
    this.bookingDates.sort((x, y) => +new Date(x) - +new Date(y));

    let dateSplit = String(this.bookingDetails.startDate).split('-');
    this.bookingForm.controls.fromDay.setValue(dateSplit[2]);
    this.bookingForm.controls.fromMonth.setValue(dateSplit[1]);
    this.bookingForm.controls.fromYear.setValue(dateSplit[0]);
    dateSplit = String(this.bookingDetails.endDate).split('-');
    this.bookingForm.controls.toDay.setValue(dateSplit[2]);
    this.bookingForm.controls.toMonth.setValue(dateSplit[1]);
    this.bookingForm.controls.toYear.setValue(dateSplit[0]);

    this.validateDate();
  }

  generateBookingDatesMum(dueDate: any){
    this.bookingDates = [];
    let sample: Array<any> = [];
    sample.push(this.bookingDetailMum.startDate);
    sample.push(this.bookingDetailMum.endDate);
    sample.push(dueDate);
    this.dueDate = new Date(dueDate);
    sample = Array.from(new Set(sample));
    sample.forEach(date=>this.bookingDates.push(new Date(date)));
    this.bookingDates.sort((x, y) => +new Date(x) - +new Date(y));
  }

  checkDueDate(date: any){
    return String(this.dueDate) == String(date) ? true : false;
  }

  validateDate(){
    let temp = this.bookingForm.controls.fromYear.value + '-' + this.bookingForm.controls.fromMonth.value
    + '-' + this.bookingForm.controls.fromDay.value;
    let fromDate = new Date(temp);
    
    temp = this.bookingForm.controls.toYear.value + '-' + this.bookingForm.controls.toMonth.value
    + '-' + this.bookingForm.controls.toDay.value;
    let toDate = new Date(temp);
    
    this.fromDateError = fromDate < this.today ? true : false;
    this.toDateError = (toDate < this.today || fromDate > toDate) ? true : false;

    if(this.Days31.includes(this.bookingForm.controls.fromMonth.value))
    {
      this.fromDaysDrop = this.daysBackup;
    }
    else if(this.Days30.includes(this.bookingForm.controls.fromMonth.value)){
      this.fromDaysDrop = this.daysBackup.slice(0,-1);
    }
    else if(new Date(this.bookingForm.controls.fromYear.value+'-02-29').getDate() === 29){
      this.fromDaysDrop = this.daysBackup.slice(0,-2);
    }
    else{
      this.fromDaysDrop = this.daysBackup.slice(0,-3);
    }

    if(this.Days31.includes(this.bookingForm.controls.toMonth.value))
    {
      this.toDaysDrop = this.daysBackup;
    }
    else if(this.Days30.includes(this.bookingForm.controls.toMonth.value)){
      this.toDaysDrop = this.daysBackup.slice(0,-1);
    }
    else if(new Date(this.bookingForm.controls.toYear.value+'-02-29').getDate() === 29){
      this.toDaysDrop = this.daysBackup.slice(0,-2);
    }
    else{
      this.toDaysDrop = this.daysBackup.slice(0,-3);
    }
  }

  updateBookingDates(){
    this.loading = true;
    let body = {
      bookingId: this.bookingDetails.bookingId,
      startDate: this.bookingForm.controls.fromYear.value + '-' + this.bookingForm.controls.fromMonth.value
                  + '-' + this.bookingForm.controls.fromDay.value,
      endDate: this.bookingForm.controls.toYear.value + '-' + this.bookingForm.controls.toMonth.value
                  + '-' + this.bookingForm.controls.toDay.value
    }

    this.fromDate = new Date(body.startDate);
    this.toDate = new Date(body.endDate);

    this.dashboardService.updateBookingDates(body)
    .subscribe((res: IBookingUpdateResponse)=>{
      $('#edit-booking-dates').modal('hide');
      this.loading = false;
      console.log("Booking Date Updated !",res);
      this.refresh.emit(res.payload);
    },err=>{
      console.error("Booking Date Update Failed:", err);
      this.loading = false;
    });
  }

}
